// extracted by mini-css-extract-plugin
export default {"section":"Section_section__F-wvK","section__title":"Section_section__title__n+Keq","section__content":"Section_section__content__867UN"};